<mat-card appearance="outlined" fxFlex>
  <mat-card-header>
    <mat-card-title>Campaigns</mat-card-title>
    <div class="text-right flex-1">
      <lib-button *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_CREATE]" icon="add"
        [matMenuTriggerFor]="addCampaignMenu">Add Campaign</lib-button>
    </div>
    <mat-menu #addCampaignMenu="matMenu">
      <button mat-menu-item (click)="onAddPunchCardCampaign()">Punch card campaign</button>
      @if (!isBrandAdmin) {
        <!-- <button mat-menu-item (click)="onAddLuckyDrawCampaign()">Lucky draw campaign</button> -->
        <!-- <button mat-menu-item (click)="onAddStaffCampaign()">Staff campaign</button> -->
        <button mat-menu-item (click)="onAddStaffPointCampaign()">Staff point campaign</button>
        <!-- <button mat-menu-item (click)="onMultiCampaign()">Multi campaign</button> -->
        <button mat-menu-item (click)="onConsumerInfoCampaign()">Info campaign (consumer)</button>
        <button mat-menu-item (click)="onStaffInfoCampaign()">Info campaign (staff)</button>
        <button mat-menu-item (click)="onOpenerCampaign()">Opener campaign</button>
        <button mat-menu-item (click)="onAddJson()">From Json</button>
      }
    </mat-menu>
  </mat-card-header>
  <mat-card-content>
    @if (isLoading) {
      <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40" />
    }
    <table class="campaigns" mat-table matSort [dataSource]="dataSource">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let element" style="padding: 0 10px;">
            <div class="type" [ngClass]="{
                  'ms': element?.strategy,
                  'pc': element?.isPunchCardStrategy,
                  'ld': element?.isLuckyDrawStrategy,
                  'sc': element?.isStaffCampaignStrategy,
                  're': element?.isReferralCampaignStrategy,
                  'ic': element?.isConsumerInformationStrategy || element?.isStaffInformationStrategy,
                  'sp': element?.isStaffPointStrategy,
                  'op': element?.isOpenerStrategy
                }">
              {{ displayCampaignType(element) }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="banner">
          <th mat-header-cell *matHeaderCellDef> Banner </th>
          <td mat-cell *matCellDef="let element">
            @if (element.photoBannerUrl) {
              <img [src]="element.photoBannerUrl" alt="banner" style="width: 60px; height: 36px; object-fit: cover; border-radius: 4px;" />
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
          <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
          <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
        </ng-container>
        <ng-container matColumnDef="expire">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let element">
            @if (element.endDate && element.endDate < now) {
              <span style="background-color: #ffebee; color: #c62828; padding: 4px 8px; border-radius: 8px; font-size: 12px; font-weight: 500;">Expired</span>
            } @else {
              <span style="background-color: #e8f5e9; color: #2e7d32; padding: 4px 8px; border-radius: 8px; font-size: 12px; font-weight: 500;">Active</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Create Date </th>
          <td mat-cell *matCellDef="let element"> {{ (element.createdAt | date:'dd/MM/yyyy HH:mm:ss') || '-' }} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let campaign">
            <div fxLayout="row" fxLayoutAlign="end">
              <lib-button variant="icon" color="primary" tooltip="Edit" icon="edit" (buttonClick)="onEdit(campaign)"
                *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE, permissions.CAMPAIGNMANAGEMENT_READ]"></lib-button>

              <lib-button variant="icon" color="primary" tooltip="Clone" icon="content_copy" (buttonClick)="onClone(campaign)"
                *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE, permissions.CAMPAIGNMANAGEMENT_READ]"></lib-button>

              <lib-button variant="icon" color="primary" tooltip="Edit Json" icon="settings"
                (buttonClick)="onEditJson(campaign)"
                *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE, permissions.CAMPAIGNMANAGEMENT_READ]"></lib-button>

              <lib-button variant="icon" color="primary" tooltip="Generate universal code" icon="qr_code_2"
                (buttonClick)="onGenerateCode(campaign)"
                *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE, permissions.CAMPAIGNMANAGEMENT_READ]"></lib-button>

              <lib-button variant="icon" color="primary" tooltip="Delete campaign" icon="delete"
                (buttonClick)="onRemove(campaign)"
                *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE, permissions.CAMPAIGNMANAGEMENT_READ]"></lib-button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['type', 'banner', 'title', 'description', 'expire', 'createdDate', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['type', 'banner', 'title', 'description', 'expire', 'createdDate', 'actions'];"></tr>
      </table>
  </mat-card-content>
</mat-card>
